// src/utils/manuscriptPages.js
//
// One definition of what a page is.
//
// The editor lays a manuscript out as real `.rv-page` sheets, so splitting the
// stored HTML on those wrappers is how every surface that shows a manuscript
// agrees on where one page ends and the next begins. This lived in three places
// — the Book Preview modal, the rail preview and the corkboard's chapter reader
// — as three copies of the same eight lines, which is three chances for them to
// drift apart.
//
// The fallback matters as much as the split: content saved before the page
// wrappers existed has no `.rv-page` at all, and anything walking
// `.rv-page .rv-page-body` would quietly find nothing in it. Wrapping it as a
// single page keeps that content visible instead of blank.

/** Legacy, unpaginated HTML presented as the one page it is. */
export function wrapAsSinglePage(html) {
  return `<div class="rv-page"><div class="rv-page-body">${html || ''}</div></div>`;
}

/**
 * The manuscript's individual page sheets, in document order.
 *
 * @param {string} html cleaned editor HTML
 * @returns {string[]} one `.rv-page` outerHTML per sheet
 */
export function splitPages(html) {
  if (!html) return [];
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  const nodes = tmp.querySelectorAll('.rv-page');
  if (nodes.length === 0) return [wrapAsSinglePage(html)];
  return Array.from(nodes).map((n) => n.outerHTML);
}
